import styled from 'styled-components';

export const Page = styled.div.attrs({
  className: 'flex flex-col items-center px-4 py-8',
})``;

export const Container = styled.div.attrs({
  className: 'container mx-auto flex max-w-6xl flex-col gap-4 pb-[100px]',
})``;

export const Section = styled.div.attrs({ className: 'w-full' })``;

export const List = styled.div.attrs({ className: 'space-y-4' })``;

export const Empty = styled.div.attrs({ className: 'text-center text-muted-foreground py-8' })``;

export const Sentinel = styled.div.attrs({ className: 'h-px w-full' })``;
